var map = {
	"./arrowup.svg": "/FqL",
	"./back.svg": "vNpC",
	"./curjob.svg": "KoP4",
	"./curprog.svg": "hnH9",
	"./score.svg": "LHNj",
	"./select.svg": "sm2+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xm7Z";


//////////////////
// WEBPACK FOOTER
// ./src/icons nonrecursive \.svg$
// module id = Xm7Z
// module chunks = 3